function getBaseUrlForTag(roomTag = 'event-venue') {
  const baseUrl = App.es6.shared.fill_variables(window.__TGV_ROUTE_SEARCH, {
    roomTag,
    subdir: window.__TGV_SEARCH_FORM_DATA.subdir,
  });

  return `${baseUrl}?location_id=${window.__TGV_SEARCH_FORM_DATA.locationId}`;
}

function initMobile(container) {
  const mobileButton = document.querySelector('.js-mobile-filter-results-button');

  mobileButton.addEventListener('click', () => {
    const template = document.getElementById('filter-column-template'); // script
    const templateTemp = document.createElement('div');
    templateTemp.innerHTML = template.innerHTML;

    const modalContent = templateTemp.querySelector('.ds-modal-content');
    modalContent.innerHTML = container.cloneNode(true).innerHTML;

    document.body.appendChild(templateTemp);

    App.track.event('location_page_interaction', {
      section: 'mobile_filters_lp',
      element: 'filter_results',
      interaction: 'click',
    });

    templateTemp.querySelector('.ds-modal__close_button').addEventListener('click', () => {
      document.body.classList.remove('lp-filters-modal-open');

      App.track.event('location_page_interaction', {
        section: 'mobile_filters_lp',
        element: 'close_modal',
        interaction: 'click',
      });

      setTimeout(() => {
        document.body.removeChild(templateTemp);
      }, 500);
    });
    templateTemp.querySelector('.lp-mobile-filters-modal--clearResults').addEventListener('click', () => {
      modalContent.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((checkbox) => {
        checkbox.checked = false;
      });

      App.track.event('location_page_interaction', {
        section: 'mobile_filters_lp',
        element: 'clear_filters_button',
        interaction: 'click',
      });
    });
    templateTemp.querySelector('.lp-mobile-filters-modal--showResults').addEventListener('click', () => {
      let baseUrl = getBaseUrlForTag(window.__TGV_ROOM_TAG);
      const queryParams = [];

      modalContent.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((checkbox) => {
        if (checkbox.checked) {
          const label = checkbox.closest('label');
          const filterValue = label.dataset.filterValue;

          if (label.dataset.element === 'event_type') {
            baseUrl = getBaseUrlForTag(filterValue);
          } else {
            queryParams.push(filterValue);
          }
        }
      });

      const url = `${baseUrl}&${queryParams.join('&')}`;

      App.track.event('location_page_interaction', {
        section: 'mobile_filters_lp',
        element: 'show_results',
        interaction: 'click',
      });

      window.location.href = `${url}&trigger_section=none`; // to avoid triggering capacity section
    });

    document.querySelectorAll('.js-filters-link').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (event.target.tagName === 'INPUT') {
          return;
        }

        App.track.event('location_page_interaction', {
          section: 'mobile_filters_lp',
          element: link.dataset.element,
          element_value: link.innerText.trim(),
          interaction: 'click',
        });
      });
    });

    document.body.classList.add('lp-filters-modal-open');
  });
}

function initDesktop() {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.js-filters-link');

    if (link) {
      App.track.event('location_page_interaction', {
        section: 'filters_sidebar',
        element: link.dataset.element,
        element_value: link.innerText.trim(),
        interaction: 'click',
      });

      const moreVenuesUrl = document.querySelector('.lp-show-more-container').dataset.url;
      const filterValue = link.dataset.filterValue;
      const filterElement = link.dataset.element;
      const triggerSection = link.dataset.triggerSection;

      event.stopPropagation();
      event.preventDefault();

      if (filterElement === 'event_type') {
        window.location.href = getBaseUrlForTag(filterValue);
        return;
      }

      window.location.href = `${moreVenuesUrl}&${filterValue}&trigger_section=${triggerSection}`;
    }
  });
}

function initShowMore(isMobile) {
  document.addEventListener('click', (event) => {
    if (event.target.classList.contains('lp-show-more')) {
      event.target.closest('.lp-show-more-container').classList.toggle('lp-show-more-container--expanded');

      const isExpanded = event.target.classList.contains('lp-show-more--less');
      App.track.event('location_page_interaction', {
        section: isMobile ? 'mobile_filters_lp' : 'filters_sidebar',
        element: isExpanded ? 'show_less_button' : 'show_more_button',
        element_value: event.target.closest('.lp-show-more-container').querySelector('h3').innerText.trim(),
        interaction: 'click',
      });
    }
  });
}

export function init() {
  const container = document.querySelector('.js-filters-container');
  if (!container) {
    return;
  }

  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  if (isMobile) {
    initMobile(container);
  } else {
    initDesktop();
  }

  initShowMore(isMobile);
}
